import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { useLayout } from '../../context/LayoutContext';
import '../../styles/components/_button.scss';

const Button = ({
  label = '',
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  className = '',
  sx = {},
  bgColor,
  textColor,
  boxShadow = 'inset 1.5px 1.5px 0px rgba(255, 255, 255, .25), inset -1.5px -1.5px 0px rgba(0, 0, 0, .1)',
  hoverColor,
  hoverTextColor,
  hoverBorderColor,
  padding,
  border,
  fontSize,
  fullWidth,
  isDisabled = false,
  ...props
}) => {
  const { layoutType } = useLayout();

  const inlineVars = {
    '--bs-btn-hover-color': hoverTextColor || '#fff',
    '--bs-btn-hover-bg': hoverColor || bgColor || '#0056b3',
    '--bs-btn-hover-border-color': hoverBorderColor || hoverColor || '#004a9f',
  };

  const baseStyle = {
    backgroundColor: bgColor,
    color: textColor,
    boxShadow,
    padding,
    fontSize,
     border,
     width: fullWidth ? '100%' : undefined,
    ...sx,
  };

  switch (layoutType) {
    case 'mui':
      return (
        <MuiButton
          variant={variant}
          disabled={isDisabled === true}
          color={color}
          size={size}
          className={`custom-button ${className}`}
          sx={{
            ...baseStyle,
            '&:hover': {
              backgroundColor: hoverColor || bgColor,
              color: hoverTextColor || textColor,
              borderColor: hoverBorderColor,
            },
          }}
          {...props}
        >
          {label || children}
        </MuiButton>
      );

    case 'scss':
    default:
      return (
        <button
          className={`custom-button btn ${className}`}
          style={{ ...inlineVars, ...baseStyle }}
          {...props}
        >
          {label || children}
        </button>
      );
  }
};


export default Button;
